import { giftCard } from "@assets/images";
import { ButtonType } from "@components/Button/types";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, H2 } from "@components/Typography";
import { Routes } from "@ctypes";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { formatCurrency } from "@utils";
import { useNavigate } from "react-router-dom";
import { styles } from "./styles";
import { RedeemCodeSuccessModalProps } from "./types";

export const RedeemCodeSuccessModal = ({ amount }: RedeemCodeSuccessModalProps) => {
  const { dismiss } = useModal();
  const navigate = useNavigate();

  const formattedAmount = formatCurrency(amount);

  const onClick = () => {
    dismiss();
    navigate(Routes.Dashboard, { replace: true });
  };

  const props: OverlayProps = {
    cta: {
      primary: {
        title: i18n.t(Translations.RedeemCodeSuccessModalPrimaryCTA),
        type: ButtonType.Inverse,
        onClick,
      },
    },
  };

  return (
    <Overlay {...props}>
      <img src={giftCard} alt="Gift Card" style={styles.image} />
      <Spacing size={SpacingSizes.L} />

      <H2 style={styles.text}>{i18n.t(Translations.RedeemCodeSuccessModalTitle)}</H2>
      <Spacing size={SpacingSizes.M} />

      <Body style={styles.text}>
        {i18n.t(Translations.RedeemCodeSuccessModalSubtitle, {
          amount: formattedAmount,
        })}
      </Body>

      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
